import {
    CcLibraryItem,
    CcLibraryItemList,
    CcComplianceRevision,
    CcComplianceHistory,
    CcComplianceItemState,
    CcComplianceTempAnswer,
    CcComplianceTempAnswerVersion,
} from "server/models"
import { CcLibrarySetList } from "client/store"
import { TableGroupedIds } from "client/components"
import { StateType } from "client/utils"

export interface CcComplianceProps {
    setId: number
    revisionId: number
    itemId: number
}

export type ComplianceRevisionList = { [setId: number]: readonly CcComplianceRevision[] }
export type ComplianceRevisionActiveList = { [setId: number]: CcComplianceRevision }
export type ComplianceRevisionValidation = { [key in keyof CcComplianceRevision]?: string }

export type ComplianceStateList = { [itemId: number]: CcComplianceItemState }

export type ComplianceHistoryList = { [itemId: number]: CcComplianceHistory[] }
export type ComplianceHistoryValidation = { [key in keyof CcComplianceHistory]?: string }

export type ComplianceTempAnswerByUser = { [userId: number]: CcComplianceTempAnswer }
export type ComplianceTempAnswerList = { [itemId: number]: ComplianceTempAnswerByUser }
export type ComplianceTempAnswerValidation = { [key in keyof CcComplianceTempAnswer]?: string }

export type ComplianceTempAnswerVersionByUser = { [userId: number]: CcComplianceTempAnswerVersion[] }

export interface CcComplianceState {
    // list
    baseRoute: string
    tableClass: string
    showColumnSettings: boolean

    itemList: CcLibraryItemList
    itemGroupedIds: { [setId: number]: TableGroupedIds }

    setList: CcLibrarySetList
    setIds: readonly number[]

    revisionList: ComplianceRevisionList
    revisionActiveList: ComplianceRevisionActiveList

    itemStateList: { [setId: number]: ComplianceStateList }
    itemHistoryList: { [setId: number]: ComplianceHistoryList }
    tempAnswerList: { [setId: number]: ComplianceTempAnswerList }

    selectedItemIds: readonly number[]
    visibleItemIds: readonly number[]

    listLoadState: StateType
    reloadList: boolean

    // popup menu
    active: CcLibraryItem
    menuShow: boolean
    menuTarget: any

    // view history
    itemDetails: CcLibraryItem
    itemState: CcComplianceItemState
    itemHistory: CcComplianceHistory[]
    tempAnswers: ComplianceTempAnswerByUser
    tempAnswerVersions: ComplianceTempAnswerVersionByUser
    tempAnswerHistory: CcComplianceHistory
    reloadAnswer: boolean
}

// list
export const CC_COMPLIANCE_BASE_ROUTE = "CC_COMPLIANCE_BASE_ROUTE"
export const CC_COMPLIANCE_COLUMN_SETTINGS = "CC_COMPLIANCE_COLUMN_SETTINGS"

export const CC_COMPLIANCE_ITEM_LIST = "CC_COMPLIANCE_ITEM_LIST"
export const CC_COMPLIANCE_ITEM_GROUPED_IDS = "CC_COMPLIANCE_ITEM_GROUPED_IDS"

export const CC_COMPLIANCE_SET_LIST = "CC_COMPLIANCE_SET_LIST"
export const CC_COMPLIANCE_SET_IDS = "CC_COMPLIANCE_SET_IDS"

export const CC_COMPLIANCE_REVISION_LIST = "CC_COMPLIANCE_REVISION_LIST"
export const CC_COMPLIANCE_REVISION_ACTIVE_LIST = "CC_COMPLIANCE_REVISION_ACTIVE_LIST"

export const CC_COMPLIANCE_ITEM_STATE_LIST = "CC_COMPLIANCE_ITEM_STATE_LIST"
export const CC_COMPLIANCE_ITEM_HISTORY_LIST = "CC_COMPLIANCE_ITEM_HISTORY_LIST"
export const CC_COMPLIANCE_TEMP_ANSWER_LIST = "CC_COMPLIANCE_TEMP_ANSWER_LIST"

export const CC_COMPLIANCE_SELECTED_ITEM_IDS = "CC_COMPLIANCE_SELECTED_ITEM_IDS"
export const CC_COMPLIANCE_VISIBLE_ITEM_IDS = "CC_COMPLIANCE_VISIBLE_ITEM_IDS"

export const CC_COMPLIANCE_LIST_LOAD_STATE = "CC_COMPLIANCE_LIST_LOAD_STATE"
export const CC_COMPLIANCE_RELOAD_LIST = "CC_COMPLIANCE_RELOAD_LIST"

export const CC_COMPLIANCE_ACTIVE = "CC_COMPLIANCE_ACTIVE"
export const CC_COMPLIANCE_POPUP_MENU_SHOW = "CC_COMPLIANCE_POPUP_MENU_SHOW"
export const CC_COMPLIANCE_POPUP_MENU_TARGET = "CC_COMPLIANCE_POPUP_MENU_TARGET"

// view history
export const CC_COMPLIANCE_ITEM_DETAILS = "CC_COMPLIANCE_ITEM_DETAILS"
export const CC_COMPLIANCE_ITEM_STATE = "CC_COMPLIANCE_ITEM_STATE"
export const CC_COMPLIANCE_ITEM_HISTORY = "CC_COMPLIANCE_ITEM_HISTORY"
export const CC_COMPLIANCE_TEMP_ANSWERS = "CC_COMPLIANCE_TEMP_ANSWERS"
export const CC_COMPLIANCE_TEMP_ANSWER_VERSIONS = "CC_COMPLIANCE_TEMP_ANSWER_VERSIONS"
export const CC_COMPLIANCE_TEMP_ANSWER_HISTORY = "CC_COMPLIANCE_TEMP_ANSWER_HISTORY"
export const CC_COMPLIANCE_RELOAD_ANSWER = "CC_COMPLIANCE_RELOAD_ANSWER"
